export const SIGNUP_USER='SIGNUP_USER';
export const LOGIN_USER ='LOGIN_USER';
export const SET_CURRENT_USER='SET_CURRENT_USER';
export const LOGOUT_USER='LOGOUT_USER';